import { render, staticRenderFns } from "./Add_career.vue?vue&type=template&id=0cb49514&scoped=true&"
import script from "./Add_career.vue?vue&type=script&lang=js&"
export * from "./Add_career.vue?vue&type=script&lang=js&"
import style0 from "./Add_career.vue?vue&type=style&index=0&id=0cb49514&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb49514",
  null
  
)

export default component.exports